import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AppSettings {
    public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public readonly DB_API_ENDPOINT = environment.dbCentralUrl;
    public apiHeaders = new Headers({ 'Content-Type': 'application/json'});
    public apiOptions = new RequestOptions({ headers: this.apiHeaders });

    setLoginStatus(isLoggedIn) {
        this.isUserLoggedIn.next(isLoggedIn);
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/providers/app-settings.ts